<template>
    <div>
        <div v-if="cookie == false">
            <div style="
            width: 100%;
            padding: 15px 15px 15px;
            margin: 4px 0 0;
            border-radius: 3px;
            background: #f85e5e;
            position: relative;
            color: #fff;
            text-align:center;
            font-family: sans-serif;
            "><strong>Por favor, ative seus cookies para acessar essa página.</strong></div>
        </div>
        <div v-else-if="leilaoNaoEncontrado" class="heading heading-border heading-middle-border heading-middle-border-center" style="margin-top: 23px;">
            <h1 class="heading-secondary" style="background:#f2f2f2;margin-top:17px;">{{ leilaoEncerrado ? 'Leilão encerrado' : 'Leilão não encontrado' }}</h1>
            <p>{{ leilaoEncerrado ? 'Este leilão já foi encerrado.' : 'Este leilão não existe ou não está disponível neste site.' }}</p>
            <a href="/" class="mb-1 mt-1 mr-1 btn btn-light btn-voltar">Voltar para a página inicial</a>
        </div>
        <div v-else class="heading heading-border heading-middle-border heading-middle-border-center" style="margin-top: 23px;">
            <h1 class="heading-secondary" style="background:#f2f2f2;margin-top:17px;">Nenhum Lote Foi encontrado</h1><br>
            <router-link v-show="leilaoId !== undefined" :to="'/leilao/index/leilao_id/'+leilaoId" class="mb-1 mt-1 mr-1 btn btn-light btn-voltar">Voltar para Listagem</router-link> 
            <a v-show="leilaoId == undefined" @click="backHistory" class="mb-1 mt-1 mr-1 btn btn-light btn-voltar">Voltar</a> 
        </div>
    </div>
</template>
<script>
export default {
    name: 'NaoEncontrado',
    props: ['cookie', 'leilaoNaoEncontrado', 'leilaoEncerrado'],
    data () {
        return {
            leilaoId: this.$route.params.id
        }
    },
    methods:{
        backHistory(){
            window.history.back()
        }
    }
}
</script>
<style scoped>
.btn-voltar{
    border: 1px solid #cca91c;
    padding: 10px;
    background: #efd56d;
}
.btn-voltar:hover{ background: #e1e1e1; }
</style>


// WEBPACK FOOTER //
// src/components/shared/NaoEncontrado.vue